import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { BrowserRouter } from 'react-router-dom';
import { clientLogs, logEvent } from './clientLogs';
import ErrorBoundary from './components/ErrorBoundary';

clientLogs.start();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals((entry) => {
  logEvent('log', 'VITALS', entry.name, { value: entry.value, id: entry.id });
});
